"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const NavItem_1 = __importDefault(require("./NavItem"));
/**
 * Nav
 * @block
 * @requiresHooks
 */
const Nav = ({ navItems, children, className, classNames = [], justifyContent = 'start', vertical = false, type = 'links', dropdownEnabled = true, dropdownAutoClose, collapseEnabled = false, }) => {
    const ref = (0, react_1.useRef)(null);
    // @ts-ignore
    (0, react_1.useEffect)(() => {
        collapseEnabled && Promise.resolve().then(() => __importStar(require('bootstrap/js/dist/collapse'))).then(({ default: Collapse }) => {
            if (!ref.current) {
                return;
            }
            const collapseElementList = [].slice.call(ref.current.querySelectorAll('.collapse-toggle'));
            collapseElementList.map((collapseToggleEl) => {
                const collapseEl = collapseToggleEl.nextElementSibling;
                const collapse = new Collapse(collapseEl, {
                    toggle: false,
                });
                collapseToggleEl.addEventListener('click', (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    collapse.toggle();
                });
                collapseEl.addEventListener('show.bs.collapse', () => {
                    var _a;
                    (_a = collapseToggleEl.parentElement) === null || _a === void 0 ? void 0 : _a.classList.add('collapse-open');
                });
                collapseEl.addEventListener('hide.bs.collapse', () => {
                    var _a;
                    (_a = collapseToggleEl.parentElement) === null || _a === void 0 ? void 0 : _a.classList.remove('collapse-open');
                });
            });
        });
        dropdownEnabled && Promise.resolve().then(() => __importStar(require('bootstrap/js/dist/dropdown'))).then(({ default: Dropdown }) => {
            if (!ref.current) {
                return;
            }
            const dropdownElementList = [].slice.call(ref.current.querySelectorAll('.dropdown-toggle'));
            dropdownElementList.map((dropdownToggleEl) => {
                dropdownToggleEl.addEventListener('show.bs.dropdown', () => {
                    var _a, _b;
                    (_a = dropdownToggleEl
                        .closest('.nav')) === null || _a === void 0 ? void 0 : _a.classList.add('dropdown-visible');
                    (_b = dropdownToggleEl.parentElement) === null || _b === void 0 ? void 0 : _b.classList.add('dropdown-open');
                });
                dropdownToggleEl.addEventListener('hide.bs.dropdown', () => {
                    var _a, _b;
                    (_a = dropdownToggleEl
                        .closest('.nav')) === null || _a === void 0 ? void 0 : _a.classList.remove('dropdown-visible');
                    (_b = dropdownToggleEl.parentElement) === null || _b === void 0 ? void 0 : _b.classList.remove('dropdown-open');
                });
            });
        });
    }, []);
    // On Heemans, when trying to render the Footer in the SSR server, I'm seeing an error because it's
    // decoding an array prop as an object { "0": "first", "1": "second" } as opposed to [ 'first', 'second' ].
    // This might be pointing to the same thing that is causing the odd characters issue on Legate.  This is a note
    // to fix the problem ( so _navItems.map is a function always ) but also to remind myself of the thread to pull on.
    // @ts-ignore
    const _navItems = navItems
        ? (Array.isArray(navItems)
            ? navItems
            : Object.values(navItems))
        : null;
    return (react_1.default.createElement("ul", { ref: ref, className: className ||
            (0, classnames_1.default)('nav', `justify-content-${justifyContent}`, vertical === true && 'flex-column', type === 'tabs' && 'nav-tabs', type === 'pills' && 'nav-pills', ...classNames) },
        _navItems &&
            _navItems.map((item, index) => react_1.default.createElement(NavItem_1.default, { item: item, key: index, dropdownEnabled: dropdownEnabled, dropdownAutoClose: dropdownAutoClose, collapseEnabled: collapseEnabled })),
        children));
};
exports.default = Nav;
